<template>
  <div>
    <!-- 时间选择组件 -->
    <date-selection :hasBorder="true"  @confirm-selection="fetchData" />
      <h3 style="text-align: center;">{{info}}</h3>
    <!-- 数据展示区 -->
    <div class="dashboard">
      <div class="left">
        <div class="stats-row">
          <!-- 总订单量卡片 -->
          <el-card class="stat-card">
            <div class="stat-header">总订单量</div>
            <div class="stat-content">
              <span class="stat-value">{{ totalOrders }}</span>
            </div>
            <div
                class="stat-footer"
                :class="totalOrdersChange > 0 ? 'positive' : (totalOrdersChange < 0 ? 'negative' : 'neutral')"
            >
              <i v-if="totalOrdersChange > 0" class="el-icon-upload2 stat-icon"></i>
              <i v-else-if="totalOrdersChange < 0" class="el-icon-download stat-icon"></i>
              <i v-else class="el-icon-video-pause stat-icon"></i>

              <template v-if="totalOrdersChange !== 0">
                {{ totalOrdersChange > 0 ? '增加' : '减少' }}
                {{ Math.abs(totalOrdersChange) }}%
              </template>
              <span v-else class="stat-neutral">数据持平</span>

              <el-tooltip>
                <template #content>
                  <div>
                    <p>当前时间段订单量：{{ totalOrders }}</p>
                    <p>上个{{ selectedType }}订单量：{{ previousTotalOrders }}</p>
                    <p v-if="totalOrdersChange !== 0">
                      环比变化：{{ totalOrdersChange > 0 ? '增加' : '减少' }} {{ Math.abs(totalOrdersChange) }}%
                    </p>
                    <p v-else>环比变化：数据持平</p>
                  </div>
                </template>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </el-card>

          <!-- 销量金额卡片 -->
          <el-card class="stat-card">
            <div class="stat-header">销量金额</div>
            <div class="stat-content">
              <span class="stat-value">¥{{ formatAmount(salesAmount) }}</span>
            </div>
            <div
                class="stat-footer"
                :class="salesAmountChange > 0 ? 'positive' : (salesAmountChange < 0 ? 'negative' : 'neutral')"
            >
              <i v-if="salesAmountChange > 0" class="el-icon-upload2 stat-icon"></i>
              <i v-else-if="salesAmountChange < 0" class="el-icon-download stat-icon"></i>
              <i v-else class="el-icon-video-pause stat-icon"></i>

              <template v-if="salesAmountChange !== 0">
                {{ salesAmountChange > 0 ? '增加' : '减少' }}
                {{ Math.abs(salesAmountChange) }}%
              </template>
              <span v-else class="stat-neutral">数据持平</span>
              <el-tooltip>
                <template #content>
                  <div>
                    <p>当前时间段销量金额：¥{{ salesAmount }}</p>
                    <p>上个{{ selectedType }}销量金额：¥{{ previousSalesAmount }}</p>
                    <p v-if="salesAmountChange !== 0">
                      环比变化：{{ salesAmountChange > 0 ? '增加' : '减少' }} {{ Math.abs(salesAmountChange) }}%
                    </p>
                    <p v-else>环比变化：数据持平</p>
                  </div>
                </template>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </el-card>

          <!-- 新增客户卡片 -->
          <el-card class="stat-card">
            <div class="stat-header">新增客户</div>
            <div class="stat-content">
              <span class="stat-value">{{ newCustomers }}</span>
            </div>
            <div
                class="stat-footer"
                :class="newCustomersChange > 0 ? 'positive' : (newCustomersChange < 0 ? 'negative' : 'neutral')"
            >
              <i v-if="newCustomersChange > 0" class="el-icon-upload2 stat-icon"></i>
              <i v-else-if="newCustomersChange < 0" class="el-icon-download stat-icon"></i>
              <i v-else class="el-icon-video-pause stat-icon"></i>

              <template v-if="newCustomersChange !== 0">
                {{ newCustomersChange > 0 ? '增加' : '减少' }}
                {{ Math.abs(newCustomersChange) }}%
              </template>
              <span v-else class="stat-neutral">数据持平</span>
              <el-tooltip>
                <template #content>
                  <div>
                    <p>当前时间段新增客户：{{ newCustomers }}</p>
                    <p>上个{{ selectedType }}新增客户：{{ previousNewCustomers }}</p>
                    <p v-if="newCustomersChange !== 0">
                      环比变化：{{ newCustomersChange > 0 ? '增加' : '减少' }} {{ Math.abs(newCustomersChange) }}%
                    </p>
                    <p v-else>环比变化：数据持平</p>
                  </div>
                </template>
                <i class="el-icon-warning"></i>
              </el-tooltip>

            </div>
          </el-card>
        </div>

        <div class="sales_chart">
          <sales-chart />
        </div>
      </div>

      <!-- 排行榜 -->
      <div class="ranking-page">
        <div class="ranking-header">
          <h1>业 绩 排 行 榜</h1>
          <p>{{ info }}</p>
        </div>

        <!-- 排行榜前三名 -->
        <div class="top-three">
          <div class="rank-card rank-second">
            <div class="crown second">NO.2</div>
            <img
                :src="rankings[1] ? rankings[1].avatar : ''"
                alt="第二名"
                class="avatar"
            />
            <div class="name">{{ rankings[1] ? rankings[1].name : '' }}</div>
            <div class="score">
              金额 {{ rankings[1] ? rankings[1].score : '' }}
            </div>
          </div>

          <div class="rank-card rank-first">
            <div class="crown first">NO.1</div>
            <img
                :src="rankings[0] ? rankings[0].avatar : ''"
                alt="第一名"
                class="avatar"
            />
            <div class="name">{{ rankings[0] ? rankings[0].name : '' }}</div>
            <div class="score">
              金额 {{ rankings[0] ? rankings[0].score : '' }}
            </div>
          </div>

          <div class="rank-card rank-third">
            <div class="crown third">NO.3</div>
            <img
                :src="rankings[2] ? rankings[2].avatar : ''"
                alt="第三名"
                class="avatar"
            />
            <div class="name">{{ rankings[2] ? rankings[2].name : '' }}</div>
            <div class="score">
              金额 {{ rankings[2] ? rankings[2].score : '' }}
            </div>
          </div>
        </div>

        <!-- 其他排名 -->
        <div
            class="rank-container"
            :style="{ maxHeight: '330px', overflowY: 'auto' }"
        >
          <div
              v-for="(item, index) in rankings.slice(3)"
              :key="index"
              class="rank-card rank-row"
          >
            <div class="rank-number">NO.{{ index + 4 }}</div>
            <img :src="item.avatar" alt="头像" class="avatar" />
            <div class="name">{{ item.name }}</div>
            <div class="score">金额 {{ item.score }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dateSelection from "./utils/DateSelection.vue";
import salesChart from "./utils/SalesChart.vue";

export default {
  name:'CustomerRanking',
  components:{
    dateSelection,
    salesChart
  },
  data() {
    return {
      totalOrders: 0,
      totalOrdersChange: 0,
      salesAmount: 0,
      salesAmountChange: 0,
      newCustomers: 0,
      newCustomersChange: 0,
      info: "",
      rankings: [],
      previousTotalOrders:0,
      previousSalesAmount:0,
      previousNewCustomers:0,
      selectedType:"",
      selectedValue:"",
    };
  },
  mounted() {
    // 初始化默认时间：当前年份和月份
    this.currentYear = new Date().getFullYear(); // 获取当前年份
    this.currentMonth = String(new Date().getMonth() + 1).padStart(2, '0'); // 获取当前月份，格式化为两位数字

    // 默认数据类型和时间范围
    const defaultType = '月度';
    const defaultValue = `${this.currentYear}-${this.currentMonth}`; // 格式为 YYYY-MM

    // 调用数据加载方法
    this.fetchData({ type: defaultType, value: defaultValue });

    // 设置描述信息
    this.info = `${this.currentYear}年${this.currentMonth}月份业务员业绩排行`;
  },
methods:{
  formatAmount(amount) {
    if (amount >= 10000) {
      return (Math.floor(amount / 10000 * 1000) / 1000).toLocaleString() + 'w'; // 转换为万，截取三位小数
    } else if (amount >= 1000) {
      return (Math.floor(amount / 1000 * 1000) / 1000).toLocaleString() + 'k'; // 转换为千，截取三位小数
    }
    return amount.toLocaleString(); // 小于1000，直接返回完整金额
  },
  fetchData({ type, value }) {
    // 接收子组件传递的数据
    this.selectedType = type;
    this.selectedValue = value;

    // 根据类型和时间更新 info
    this.updateInfo(type, value);

    //订单数量，金额，新增客户统计
    this.fetchEmployeeRankingData(type, value);
    //排行榜数据
    this.fetchRankingData(type, value);
  },
  updateInfo(type, value) {
    if (type === "年度") {
      this.info = `${value}业务员业绩排行`;
    } else if (type === "季度") {
      const [year, quarter] = value.split("-Q"); // 分离年份和季度
      const quarterText = ["第一季度", "第二季度", "第三季度", "第四季度"][parseInt(quarter) - 1]; // 转换为中文描述
      this.info = `${year}年${quarterText}业务员业绩排行`;
    } else if (type === "月度") {
      const [year, month] = value.split("-");
      this.info = `${year}年${month}月份业务员业绩排行`;
    }
  },

  fetchEmployeeRankingData(type, value) {
    // 创建请求参数
    const params = {
      type: type,
      value: value
    };
    // 发送请求到后端，获取数据
    this.$http.get("/employeeRanking/dataInfo", { params })
        .then(response => {
          const data = response.data;

          this.totalOrders = data.totalOrders;
          this.salesAmount = data.salesAmount;
          this.newCustomers = data.newCustomers;

          // 上一时间段数据
          this.previousTotalOrders = data.previousTotalOrders;
          this.previousSalesAmount = data.previousSalesAmount;
          this.previousNewCustomers = data.previousNewCustomers;

          // 计算增减百分比
          this.totalOrdersChange = this.previousTotalOrders === 0
              ? (this.totalOrders > 0 ? 100 : 0) // 如果上个时间段为 0，根据当前值判断增幅
              : (((this.totalOrders - this.previousTotalOrders) / this.previousTotalOrders) * 100).toFixed(2);

          this.salesAmountChange = this.previousSalesAmount === 0
              ? (this.salesAmount > 0 ? 100 : 0) // 如果上个时间段为 0，根据当前值判断增幅
              : (((this.salesAmount - this.previousSalesAmount) / this.previousSalesAmount) * 100).toFixed(2);

          this.newCustomersChange = this.previousNewCustomers === 0
              ? (this.newCustomers > 0 ? 100 : 0) // 如果上个时间段为 0，根据当前值判断增幅
              : (((this.newCustomers - this.previousNewCustomers) / this.previousNewCustomers) * 100).toFixed(2);
        }).catch(error => {
          console.error("获取数据失败:", error);
        });
  },
  fetchRankingData(type, value) {
    this.$http.get("employeeRanking/dataRanking", { params: { type, value } })
        .then(response => {
          // 假设返回的数据格式为 [{ name, avatar, score }, ...]
          this.rankings = response.data;

        })
        .catch(error => {
          console.error("Error fetching ranking data:", error);
          this.rankings = []; // 清空数据以防止显示错误信息
        });
  },

}

};
</script>

<style scoped>
.left{
  width: 66%;
}
.dashboard {
  margin-top: 20px;
  display: flex;
}
.stats-row {
  display: flex;
  justify-content: space-between; /* 卡片紧挨排列 */
  align-items: stretch; /* 高度一致 */
  gap: 10px; /* 卡片之间的间距，尽量紧凑 */

  height: 150px;
  margin-right: 15px;
}

.stat-card {
  flex: 1; /* 每张卡片均匀分布 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px; /* 内边距 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 卡片阴影效果 */
}

.stat-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #606266; /* 标题颜色 */
}

.stat-content {
  font-size: 30px;
  font-weight: bold;
  color: #303133; /* 内容颜色 */
}

.stat-footer {
  font-size: 14px;
  margin-top: 10px;
  color: #606266; /* 默认字体颜色 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 图标颜色控制 */
.stat-footer.positive .stat-icon {
  color: green; /* 增加时图标为绿色 */
}
.stat-footer.negative .stat-icon {
  color: red; /* 减少时图标为红色 */
}
.stat-footer.neutral .stat-icon {
  color: gray; /* 持平时图标为灰色 */
}

.stat-icon {
  margin-right: 5px; /* 图标与文字的间距 */
  font-size: 14px;
}
.sales_chart{
  width:100%
}


/*排行榜*/
.ranking-page {

  background: linear-gradient(to bottom, #ebf4f8, #90a4ae);

  color: #333;
  padding: 20px;
  text-align: center;
  width: 30%;
  border-radius: 10px;
}

.ranking-header h1 {
  font-size: 35px;
  margin: 0;
  font-family: 'Arial', sans-serif;
}

.ranking-header p {
  font-size: 14px;
  margin: 5px 0 30px;
  font-family: 'Arial', sans-serif;
}

.top-three {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
  position: relative; /* 为了让排名卡片可以进行相对定位 */
  margin-top: 55px;
}

.rank-card {
  background: #fff;
  color: #333;
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 120px;
  position: relative;
  transition: transform 0.3s ease, top 0.3s ease; /* 添加动画效果 */
}
/* 第一名特殊样式 */
.rank-first {
  top: -20px; /* 向上移动 */
  transform: scale(1.2); /* 放大整体尺寸 */
  z-index: 10; /* 确保第一名卡片在最前面 */
}

.rank-first .avatar {
  width: 80px; /* 第一名头像更大 */
  height: 80px;
}
.rank-card .crown {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 50%;
  color: #fff;
}

.crown.first {
  background: #f5c518;
}

.crown.second {
  background: #d6d6d6;
}

.crown.third {
  background: #a46628;
}

.rank-card .avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 10px auto;
}

.rank-card .name {
  font-size: 14px;
  font-weight: bold;
}

.rank-card .score {
  font-size: 12px;
  color: #666;
}

.rank-container {
  background: #fff;
  color: #333;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  max-height: 400px;
  overflow-y: scroll;
  padding: 10px;
}

.rank-row {
  background: #ecf5ff; /* 卡片背景色 */
  border-radius: 10px; /* 卡片圆角 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 卡片阴影 */
  margin-bottom: 15px; /* 卡片间隔 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
  width: 100%; /* 撑满父容器宽度 */
  box-sizing: border-box; /* 包括 padding 在内 */
}

.rank-row:last-child {
  border-bottom: none;
  margin-bottom: 0; /* 最后一个卡片不需要间隔 */
}

.rank-row .rank-number {
  font-size: 16px;
  font-weight: bold;
  width: 50px;
}

.rank-row .avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.rank-row .name {
  flex: 1;
  text-align: left;
  margin-left: 10px;
}

.rank-row .score {
  font-size: 14px;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// CustomerRanking.vue?31603946